import { API_URL } from '../config';

const API_BASE_URL = API_URL;

// ============================================
// USERS API
// ============================================

export const userAPI = {
  // Get all users
  getAll: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await fetch(`${API_BASE_URL}/users?${params}`);
    return response.json();
  },

  // Get single user
  getById: async (id) => {
    const response = await fetch(`${API_BASE_URL}/users/${id}`);
    return response.json();
  },

  // Create user
  create: async (userData) => {
    const response = await fetch(`${API_BASE_URL}/users`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userData),
    });
    return response.json();
  },

  // Update user
  update: async (id, userData) => {
    const response = await fetch(`${API_BASE_URL}/users/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(userData),
    });
    return response.json();
  },

  // Delete user
  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL}/users/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

// ============================================
// EVENTS API
// ============================================

export const eventAPI = {
  // Get all events
  getAll: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await fetch(`${API_BASE_URL}/events?${params}`);
    return response.json();
  },

  // Get single event
  getById: async (id) => {
    const response = await fetch(`${API_BASE_URL}/events/${id}`);
    return response.json();
  },

  // Create event
  create: async (eventData) => {
    const response = await fetch(`${API_BASE_URL}/events`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(eventData),
    });
    return response.json();
  },

  // Update event
  update: async (id, eventData) => {
    const response = await fetch(`${API_BASE_URL}/events/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(eventData),
    });
    return response.json();
  },

  // Delete event
  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL}/events/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

// ============================================
// GALLERY API
// ============================================

export const galleryAPI = {
  // Get all gallery items
  getAll: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await fetch(`${API_BASE_URL}/gallery?${params}`);
    return response.json();
  },

  // Get single gallery item
  getById: async (id) => {
    const response = await fetch(`${API_BASE_URL}/gallery/${id}`);
    return response.json();
  },

  // Create gallery item
  create: async (galleryData) => {
    const response = await fetch(`${API_BASE_URL}/gallery`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(galleryData),
    });
    return response.json();
  },

  // Update gallery item
  update: async (id, galleryData) => {
    const response = await fetch(`${API_BASE_URL}/gallery/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(galleryData),
    });
    return response.json();
  },

  // Delete gallery item
  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL}/gallery/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

// ============================================
// LOGOS API
// ============================================

export const logoAPI = {
  // Get all logos
  getAll: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await fetch(`${API_BASE_URL}/logos?${params}`);
    return response.json();
  },

  // Get single logo
  getById: async (id) => {
    const response = await fetch(`${API_BASE_URL}/logos/${id}`);
    return response.json();
  },

  // Create logo
  create: async (logoData) => {
    const response = await fetch(`${API_BASE_URL}/logos`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(logoData),
    });
    return response.json();
  },

  // Update logo
  update: async (id, logoData) => {
    const response = await fetch(`${API_BASE_URL}/logos/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(logoData),
    });
    return response.json();
  },

  // Toggle featured status
  toggleFeatured: async (id) => {
    const response = await fetch(`${API_BASE_URL}/logos/${id}/featured`, {
      method: 'PUT',
    });
    return response.json();
  },

  // Delete logo
  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL}/logos/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

// ============================================
// MEDIA API
// ============================================

export const mediaAPI = {
  // Get all media
  getAll: async (filters = {}) => {
    const params = new URLSearchParams(filters).toString();
    const response = await fetch(`${API_BASE_URL}/media?${params}`);
    return response.json();
  },

  // Get single media
  getById: async (id) => {
    const response = await fetch(`${API_BASE_URL}/media/${id}`);
    return response.json();
  },

  // Create media
  create: async (mediaData) => {
    const response = await fetch(`${API_BASE_URL}/media`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mediaData),
    });
    return response.json();
  },

  // Update media
  update: async (id, mediaData) => {
    const response = await fetch(`${API_BASE_URL}/media/${id}`, {
      method: 'PUT',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(mediaData),
    });
    return response.json();
  },

  // Delete media
  delete: async (id) => {
    const response = await fetch(`${API_BASE_URL}/media/${id}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

// ============================================
// SETTINGS API
// ============================================

export const settingAPI = {
  // Get all settings
  getAll: async () => {
    const response = await fetch(`${API_BASE_URL}/settings`);
    return response.json();
  },

  // Get single setting
  getByKey: async (key) => {
    const response = await fetch(`${API_BASE_URL}/settings/${key}`);
    return response.json();
  },

  // Create or update setting
  set: async (key, value, description, category, type) => {
    const response = await fetch(`${API_BASE_URL}/settings`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        key,
        value,
        description,
        category: category || 'general',
        type: type || 'string',
      }),
    });
    return response.json();
  },

  // Delete setting
  delete: async (key) => {
    const response = await fetch(`${API_BASE_URL}/settings/${key}`, {
      method: 'DELETE',
    });
    return response.json();
  },
};

// ============================================
// FILE UPLOAD API
// ============================================

export const uploadAPI = {
  // Upload single file
  uploadFile: async (file, folder = 'general') => {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('folder', folder);

    const response = await fetch(`${API_BASE_URL}/upload`, {
      method: 'POST',
      body: formData,
    });
    return response.json();
  },

  // Upload multiple files
  uploadMultiple: async (files, folder = 'general') => {
    const formData = new FormData();
    files.forEach(file => formData.append('files', file));
    formData.append('folder', folder);

    const response = await fetch(`${API_BASE_URL}/upload-multiple`, {
      method: 'POST',
      body: formData,
    });
    return response.json();
  },
};

export default {
  userAPI,
  eventAPI,
  galleryAPI,
  logoAPI,
  mediaAPI,
  settingAPI,
  uploadAPI,
};
